import config, { PUBLIC_VAPID_KEY } from '../../config'

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }
  return outputArray
}

function getAuthToken() {
  const tokenRaw = localStorage.getItem('token')
  if (!tokenRaw) return null
  try {
    return JSON.parse(tokenRaw)
  } catch {
    return null
  }
}

let registrationPromise = null

export function initPushServiceWorker() {
  if (!('serviceWorker' in navigator)) return
  ensureServiceWorkerRegistered().catch((err) =>
    console.warn('[push] registro service worker:', err)
  )
}

export function ensureServiceWorkerRegistered() {
  if (!('serviceWorker' in navigator)) {
    return Promise.reject(new Error('Service Worker no disponible'))
  }
  if (!registrationPromise) {
    const base = process.env.BASE_URL || '/'
    const workerUrl = base.endsWith('/') ? `${base}worker.js` : `${base}/worker.js`
    registrationPromise = navigator.serviceWorker.register(workerUrl, {
      scope: base
    })
  }
  return registrationPromise
}

/**
 * Sincroniza suscripción push y la persiste en backend. Requiere JWT en localStorage.
 */
export async function syncPushSubscription() {
  const token = getAuthToken()
  if (!token) {
    return { exito: false, motivo: 'usuario_no_autenticado' }
  }

  if (!window.isSecureContext) {
    return {
      exito: false,
      motivo: 'contexto_no_seguro',
      detalle:
        'Push requiere HTTPS o localhost. Si abriste por IP/http, el navegador puede fallar con AbortError.'
    }
  }

  if (!('PushManager' in window)) {
    return {
      exito: false,
      motivo: 'push_no_soportado',
      detalle: 'Este navegador no soporta Push API.'
    }
  }

  const perm = Notification.permission
  if (perm !== 'granted') {
    return { exito: false, motivo: 'permiso_denegado', detalle: perm }
  }

  await ensureServiceWorkerRegistered()
  const reg = await navigator.serviceWorker.ready

  if (reg.active) {
    reg.active.postMessage({
      type: 'SET_NOTIF_CONFIG',
      apiUrl: config.API_URL,
      token
    })
  }

  let sub = await reg.pushManager.getSubscription()
  if (sub) {
    await sub.unsubscribe().catch(() => {})
  }

  try {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(PUBLIC_VAPID_KEY)
    })
  } catch (error) {
    const isAbort = error?.name === 'AbortError'
    if (isAbort) {
      const ua = navigator.userAgent || 'desconocido'
      const origen = window.location?.origin || 'desconocido'
      error.message =
        `[push] AbortError al suscribir. Origen=${origen}. ` +
        `Si usas Brave/Chromium, verificá que no esté desactivado el servicio de push (FCM). ` +
        `UA=${ua}. Mensaje original: ${error.message || 'sin detalle'}`
    }
    throw error
  }

  const subJson = sub.toJSON ? sub.toJSON() : sub
  localStorage.setItem('subscription', JSON.stringify(subJson))

  const res = await fetch(`${config.API_URL}/user/subscripcion`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: token
    },
    body: JSON.stringify({ subscripcion: subJson })
  })

  const body = await res.json().catch(() => ({}))
  if (!res.ok) {
    const msg = body.message || body.detalle || `HTTP ${res.status}`
    const err = new Error(msg)
    err.body = body
    throw err
  }

  return { exito: true, data: body }
}

export async function syncPushSubscriptionWithRetry(intentos = 4) {
  let ultimo
  for (let i = 0; i < intentos; i++) {
    try {
      const r = await syncPushSubscription()
      if (r.exito) return r
      if (
        r.motivo === 'usuario_no_autenticado' ||
        r.motivo === 'permiso_denegado'
      ) {
        return r
      }
      ultimo = r
    } catch (e) {
      ultimo = e
      console.warn(`[push] intento ${i + 1}/${intentos}:`, e.message)
    }
    await new Promise((resolve) => setTimeout(resolve, 350 * (i + 1)))
  }
  throw ultimo instanceof Error ? ultimo : new Error(String(ultimo))
}
